const _ = require('lodash');

exports.parseError = (errorObj) => {
  errorObj.name = '';
  errorObj = JSON.parse(errorObj.toString());
  errorObj = errorObj && errorObj.code ? errorObj : { code: 'INTERNAL_SERVER_ERROR', message: exportLib.response[500] };
  return errorObj;
};

// Log the error , terminate process and return error response
exports.handleError = (res, errorObj, meta = {}) => {
  const err = errorObj.message;
  let status = err.code || err.status || err.statusCode || errorObj.code || RESPONSECODES.INTERNAL_SERVER_ERROR;
  let errMessage = status < 500 ? err : "An error occurred! Please try again!";
  if (status === 500 && err.name === "SequelizeValidationError") {
    const error = err.errors?.[0];
    if (error) {
      status = error?.original?.code || status;
      errMessage = error.message || errMessage;
    }
  }
  if (!_.isString(errMessage)) {
    errMessage = errMessage.message || "Something went wrong! Please try again later!";
  }
  return res.status(status)
    .send({ error: { message: errMessage, meta } });
}
